<!--既往药物治疗-->
<script setup>
import { computed, reactive, watch,ref ,nextTick} from "vue";
import { useCrfStore } from "@/stores/crf";
import upload from "@/components/upload1.vue"

import {useCommonStore} from "@/stores/common.js"
const commonStore = useCommonStore()
//不是筛选期
let notScreen = ref(false)
notScreen.value = commonStore.funNotScreen

//是不是v0
let isv0 = ref(false)
isv0.value = commonStore.isV0

const crfStore = useCrfStore();

// 定义组件属性
const props = defineProps({
  formModel: {},
  prefix: "",
  type: null
});

// 表单对象
const model = reactive(props.formModel);
// console.log(Object.keys(model),model.fields,"model")
// console.log(model.fields.姓名,"model")

//prefix:prefix="'【'+(crfFormIndex>2?'补充':'既往')+'门脉高压药物治疗】'"
let attrs = ref('【'+ (notScreen.value?'补充':'既往') +'门脉高压药物治疗】')


// 随机生成n位纯字母的字符串
const fun = (e=0)=>{
    let str = ''
    for (let index = 0; index < e; index++) {
        let num = Math.floor(Math.random()*26)
        //String.fromCharCode()传入ASCII值返回相应的大写字符
        str += String.fromCharCode(65 + num)  
    }
    return str
  }
  // console.log(fun(6)) 

  // 生成一个不同字符串的数组
  const pushstr = (e)=>{
    for (let index = 0; index < e; index++) {
    let item = fun(6)
    if(!drugpicarr.includes(item)){
      drugpicarr.push(item)
    }else{
      index--
    }
  }
  }



// 中药方剂
let drugpicarr = [];
  pushstr(40)
 
// 往数组里写单个不重复的字符串
  const oneStr = ()=>{
    for (let index = 0; index < 1; index++) {
      let item = fun(6)
      if(!model.fields[props.type].drugpicarr.includes(item)){
        // 加到表单对象的结构中去
        model.fields[props.type].drugpicarr.push(item)
      }else{
        index--
      }
    }
  }
  // 删掉一个字符串
  const delStr = (index)=>{
    model.fields[props.type].drugpicarr.splice(index,1)
  }

// let arra = []


// console.dir(arra,"arra")
// arra.length ||= [4,23,34]

// console.log(arra.length,"haohao")

// console.log(drugpicarr,"40个数")
// console.log(model.fields[props.type].drugpicarr,"heihie")
// if(!model.fields[props.type]?.drugpicarr){
    // pushstr(40)

    
    // Reflect.set(model.fields[props.type], `drugpicarr`, [...drugpicarr])
    // model.fields[props.type].drugpicarr = [] 
    // model.fields[props.type].drugpicarr = [...drugpicarr];
// }

// model.fields[props.type].drugpicarr ??= [...drugpicarr];
  // console.log(model.fields[props.type].drugpicarr[0],'computed')
// 计算属性
let picname = computed(()=>{
  model.fields[props.type]?.drugpicarr? '' :model.fields[props.type].drugpicarr = [...drugpicarr];
  // console.log(model.fields[props.type].drugpicarr,'computed')
  return model.fields[props.type].drugpicarr
})

 
//   // console.log(model.fields[props.type],'first')




// 新增一个药品
const adddrug = ()=>{
  model.fields[`${props.type}`].drugArrays.push({})
  oneStr()
}


// 值的保存应该每个记录的值是一个对象，然后放进数组
const drugArrays = computed(() => {
  model.fields[`${props.type}`].drugArrays ?'' :model.fields[`${props.type}`].drugArrays = [{}]
  return model.fields[`${props.type}`].drugArrays;
});


let title = ref(attrs.value.replace("【", "").replace("】", ""))
// const title = computed(() => {
//   if (props.prefix) {
//     return props.prefix.replace("【", "").replace("】", "");
//   } else {
//     return "";
//   }
// });

// 中药方剂图片的基准
let basisPic = ref(0)
// const isVisible = computed(() => {
//   let result = {};
//   // 单选的选择
//   [`${props.prefix}受试者是否进行过${title.value}_是`].forEach((field) => {
//     const key = field.split("_")[0];
//     const value = field.split("_")[1];
//     result[field] = model.fields[props.type][key] === value;
//   });
//   return result;
// });

// const drugs = computed(() => {
//   let result = [];
//   [1, 2, 3, 4, 5].forEach((key) => {
//     const 药物占位符 = `${props.prefix}${key}`;
//     const 药物名称 = `${props.prefix}${key}药物名称`;
//     const 开始日期 = `${props.prefix}${key}开始日期`;
//     const 结束日期 = `${props.prefix}${key}结束日期`;
//     const 研究终止仍在使用 = `${props.prefix}${key}研究终止仍在使用`;
//     if (model.fields[props.type][药物占位符]) {
//       result.push({
//         药物占位符: model.fields[props.type][药物占位符],
//         药物名称: model.fields[props.type][药物名称],
//         开始日期: model.fields[props.type][开始日期],
//         结束日期: model.fields[props.type][结束日期],
//         研究终止仍在使用: model.fields[props.type][研究终止仍在使用]
//       });
//     }
//   });
//   return result;
// });

// const selectNo = function() {
//   // 文本
//   [`${props.prefix}治疗目的`].forEach((key) => {
//     model.fields[props.type][key] = null;
//   });
//   [0, 1, 2, 3, 4].forEach(() => removeDrug(0));
// };

// const addDrug = function() {
//   [1, 2, 3, 4, 5].every((key) => {
//     const 药物占位符 = `${props.prefix}${key}`;
//     const 药物名称 = `${props.prefix}${key}药物名称`;
//     const 开始日期 = `${props.prefix}${key}开始日期`;
//     const 结束日期 = `${props.prefix}${key}结束日期`;
//     const 研究终止仍在使用 = `${props.prefix}${key}研究终止仍在使用`;
//     if (typeof (model.fields[props.type][药物占位符]) === "undefined" || model.fields[props.type][药物占位符] === null) {
//       model.fields[props.type][药物占位符] = key;
//       return false;
//     }
//     return true;
//   });
// };

// const removeDrug = function(index) {
//   let result = [];
//   drugs.value.forEach((key, i) => {
//     const 药物名称 = `${props.prefix}${i + 1}药物名称`;
//     const 开始日期 = `${props.prefix}${i + 1}开始日期`;
//     const 结束日期 = `${props.prefix}${i + 1}结束日期`;
//     const 研究终止仍在使用 = `${props.prefix}${key + 1}研究终止仍在使用`;
//     if (index !== i) {
//       result.push({
//         药物占位符: (i + 1),
//         药物名称: model.fields[props.type][药物名称],
//         开始日期: model.fields[props.type][开始日期],
//         结束日期: model.fields[props.type][结束日期],
//         研究终止仍在使用: model.fields[props.type][研究终止仍在使用]
//       });
//     }
//   });

//   [1, 2, 3, 4, 5].forEach((key) => {
//     const 药物占位符 = `${props.prefix}${key}`;
//     const 药物名称 = `${props.prefix}${key}药物名称`;
//     const 开始日期 = `${props.prefix}${key}开始日期`;
//     const 结束日期 = `${props.prefix}${key}结束日期`;
//     const 研究终止仍在使用 = `${props.prefix}${key}研究终止仍在使用`;

//     model.fields[props.type][药物占位符] = null;
//     model.fields[props.type][药物名称] = null;
//     model.fields[props.type][开始日期] = null;
//     model.fields[props.type][结束日期] = null;
//     model.fields[props.type][研究终止仍在使用] = null;
//   });

//   result.forEach((item, i) => {
//     const 药物占位符 = `${props.prefix}${i + 1}`;
//     const 药物名称 = `${props.prefix}${i + 1}药物名称`;
//     const 开始日期 = `${props.prefix}${i + 1}开始日期`;
//     const 结束日期 = `${props.prefix}${i + 1}结束日期`;
//     const 研究终止仍在使用 = `${props.prefix}${i + 1}研究终止仍在使用`;

//     model.fields[props.type][药物占位符] = (i + 1);
//     model.fields[props.type][药物名称] = item.药物名称;
//     model.fields[props.type][开始日期] = item.开始日期;
//     model.fields[props.type][结束日期] = item.结束日期;
//     model.fields[props.type][研究终止仍在使用] = item.研究终止仍在使用;
//   });

//   return result;
// };

// 节省代码长度，在模板中使用
const crfFields = computed(() => {
  return model.fields[`${props.type}`];
});

// 记录时哪一个药的日期
let index = ref(null)
const inport = (e)=>{
  // console.log(e,'选择结束日期的打印')
  index.value = e
}
const disabledDate = (val)=>{
  // return val.getTime() > new Date().getTime()
  
  if(model.fields[`${props.type}`].drugArrays[index.value]?.['开始日期']) {
      // console.log(new Date(model.fields[`${props.type}`].drugArrays[index.value]?.['开始日期']).getTime())
      return val.getTime() < new Date(model.fields[`${props.type}`].drugArrays[index.value]?.['开始日期']).getTime()
  }else{
    return val.getTime() < new Date().getTime()
  }
}
// // 字段自动校验用于赋值 prop
// const itemProp = function(prop) {
//   return `fields[${props.type}]['endoscopeArrays'][${prop}]`;
// };
// 字段自动校验用于赋值 prop
const itemProp = function(prop) {
  return `fields[${props.type}]['drugArrays'][${prop}]`;
};
</script>
<template v-if="crfFields">
   <!-- <p>----{{ attrs }}--{{title}}--</p> -->
  <h3>{{ title }}</h3>
  <el-form-item label="是否适用肝筛选期门脉高压药物治疗数据"  v-if="crfFields && isv0" class="redStar">
      <el-radio-group v-if="notScreen" v-model="crfFields['门脉高压药物治疗是否适用肝筛选期数据']">
        <el-radio label="是" prop="是"></el-radio>
        <el-radio label="否" prop="否"></el-radio>
      </el-radio-group>
    </el-form-item>
      <template v-if="crfFields?.['门脉高压药物治疗是否适用肝筛选期数据'] == '否' || !isv0">
        <el-form-item :label="'是否' + (notScreen?'新增':'') + title" class="redStar">
          <el-radio-group v-model="crfFields[`${attrs}是否进行过${title}`]" >
            <el-radio label="是"></el-radio>
            <el-radio label="否"></el-radio>
          </el-radio-group>
        </el-form-item>

        <template v-for="(item, index) in drugArrays" :key="index" v-if="crfFields[`${attrs}是否进行过${title}`] == '是'">
          <h4>{{title}}药品{{ index + 1 }}</h4>
          <el-form-item  label="药物名称" class="redStar yaopin" :prop="itemProp(`${index}['药品名称']`)" :rules="crfStore.radioRules(`第${index + 1}内镜药物名称`)">   
            <!-- <p>{{ itemProp(`${index}['药物名称']`) }}</p> -->
            <el-radio-group v-model="drugArrays[index]['药品名称']">
            <el-radio label="卡维地洛"></el-radio>
            <el-radio label="普萘洛尔"></el-radio>
            <el-radio label="抗凝药物"></el-radio>
            <el-radio label="中药"></el-radio>
              <!-- 中药下面的二级选项 -->
              <div v-if="drugArrays[index]['药品名称']?.includes('中药')" style="padding-left: 25px;">
                <el-radio-group v-model="drugArrays[index]['药品名称_中药']">
                  <el-radio label="中成药" style="display: flex;"></el-radio>
                  <el-radio label="中药方剂"></el-radio>
                </el-radio-group>
              </div>
            <el-radio label="其他"></el-radio>
          </el-radio-group>
        
          
          <!-- 选择其他 -->
          <el-input v-if="drugArrays && drugArrays[index]['药品名称'] == '其他'" v-model="drugArrays[index]['其他药品']" placeholder="请输入其他药品"></el-input>
          </el-form-item>

          
          <!-- 抗凝药物名称 -->
          <el-form-item label="药物名称" class="redStar" v-if="drugArrays[index]['药品名称']?.includes('抗凝药物')">
              <el-input class="jl_input" v-model="drugArrays[index]['抗凝药物名称']" placeholder="请输入药物名称">
                <!-- <template #append>mg</template> -->
              </el-input>
          </el-form-item>

          <!-- 非中药显示剂量 -->
          <el-form-item label="剂量（mg）" class="redStar" v-if="drugArrays[index]['药品名称'] && !drugArrays[index]['药品名称']?.includes('中药')">
              <el-input class="jl_input" v-model="drugArrays[index]['剂量']" placeholder="请输入剂量">
                <template #append>mg</template>
              </el-input>
          </el-form-item>
          <!-- 中药的中成药显示用法、用量 -->
          <template v-if="drugArrays[index]['药品名称']?.includes('中药') && drugArrays[index]['药品名称_中药']?.includes('中成药')">
            <el-form-item label="用法" class="redStar">
              <el-input class="jl_input" v-model="drugArrays[index]['中成药_用法']" placeholder="请输入用法">
                <!-- <template #append>mg</template> -->
              </el-input>
            </el-form-item>
            <el-form-item label="用量" class="redStar">
              <el-input class="jl_input" v-model="drugArrays[index]['中成药_用量']" placeholder="请输入用量">
                <!-- <template #append>mg</template> -->
              </el-input>
            </el-form-item>
          </template>

          <!-- 中药的中药方剂显示名称和拍照上传 -->
          <template v-if="drugArrays[index]['药品名称']?.includes('中药') && drugArrays[index]['药品名称_中药']?.includes('中药方剂')">
            <el-form-item label="名称" class="redStar">
              <el-input class="jl_input" v-model="drugArrays[index]['中药方剂_名称']" placeholder="请输入名称">
                <!-- <template #append>mg</template> -->
              </el-input>
            </el-form-item>

            <!-- {{ ['1','2','3','4','5','6','7','8','9','10']}} -->

            <el-form-item label="拍照上传" class="redStar">
              <!-- 必须要保证名字的唯一性 -->
              <!-- {{ Math.floor( Math.random()*10) }} -->
                <upload :type="props.type" :data="model" :name="`jwywzl${picname?.[index]}`" btn_name="拍照上传"></upload>
            </el-form-item>
          </template>
          


          <el-form-item label="开始日期" class="redStar" v-if="drugArrays[index]['药品名称']">
            <el-date-picker v-model="drugArrays[index]['开始日期']"
                            type="date" placeholder="选择开始日期"
                            value-format="YYYY-MM-DD" />
          </el-form-item>

          <el-form-item label="结束日期" class="redStar" v-if="drugArrays[index]['药品名称']">
              <el-date-picker v-model="drugArrays[index]['结束日期']" @focus="inport(index)"
                              type="date" placeholder="选择结束日期"
                              :disabled-date="disabledDate"
                              value-format="YYYY-MM-DD" />
              <p class="prompt">说明：无法确认具体使用时间则具体到月即可</p>
            </el-form-item>
            <!-- 需要解决减少时，点击的是有图片的前面还是后面 -->
          <button class="del" v-if="drugArrays.length>1" @click.prevent="drugArrays.splice(index,1);delStr(index)">删除第{{ index + 1 }}次{{ title }} 药品</button>
          <hr>
        </template>
        <p><button v-if="model.fields[`${props.type}`].drugArrays?.length <5 && crfFields[`${attrs}是否进行过${title}`] == '是'" 
          class="add" @click.prevent="adddrug()">增加药物</button></p>
      </template>
    
</template> 
<style lang="scss" scoped>
.del{
  margin-left: 250px;

}
.add{
  margin-left: 250px;
}
.prompt{
  width: 1000px;
  margin-top: -2px;
  color: rgb(151, 156, 156);
  font-size: 14px;
}
.jl_input{
  width: 220px;
}
.el-radio-group{
  // display: block;
  width: 100%;
}
::v-deep .btn_fiexd {
    margin-left: 0px; 
    margin-top: 0px;
}
.yaopin{
  // width: 100%;
  .el-radio {
    width: 100%;
  }


}
.zhongyao{
  top: 20px;
  left: 40px;
  display: block;
  ::v-deep .el-radio {
    width: 100%;
  }
}
.zyrelative{
  ::v-deep .el-radio__label{
     position: relative;
  }
 
}
</style>